import type { IconData } from '@stacksjs/iconify-core'

export const deepfakeTechnology1Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M6.5 9a4.5 4.5 0 1 1 8.67 1.695l3.555 3.555H23.5a1.75 1.75 0 1 1 0 3.5H18a1.75 1.75 0 0 1-1.237-.513l-4.068-4.067A4.5 4.5 0 0 1 6.5 9m-5 15a4.5 4.5 0 0 1 8.647-1.75H23.5a1.75 1.75 0 1 1 0 3.5H10.147A4.501 4.501 0 0 1 1.5 24M10 35.5a4.5 4.5 0 1 0 4.17 2.805l3.555-3.555H23.5a1.75 1.75 0 1 0 0-3.5H17c-.464 0-.91.184-1.237.513l-4.068 4.067A4.5 4.5 0 0 0 10 35.5\" clip-rule=\"evenodd\"/><path fill=\"#8fbffa\" d=\"M23.5 2.5A1.5 1.5 0 0 0 22 4v40.867a1.5 1.5 0 0 0 1.5 1.5H32a1.5 1.5 0 0 0 1.5-1.5V41.11l2.918.493a4.5 4.5 0 0 0 5.233-4.06l.484-5.756a13.5 13.5 0 0 0 3.452-1.564c1.639-1.06 1.65-3.081.777-4.374l-3.919-5.8C41.705 10.234 33.506 2.5 23.5 2.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default deepfakeTechnology1Flat
